import type { Phrases } from '../Phrases.d';

import React, { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';
import { Legend } from '../../../../components/Element';
import { Fieldset } from '/react4xp/components/react-hook-form/Fieldset';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { PillShapeButtonGroup } from './PillShapeButtonGroup';
import { PillShapeOtherTextField } from './PillShapeOtherTextField';
import {
	type SubstanceForm,
	COMMON_FIELD_NAME,
	SUBSTANCE_FORM,
} from '../constants';


const PILL_SHAPE_LEGEND_ID = 'pillShapeLegend';


export const PillShapeFieldset = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const legend = phrases['notificationForm.common.pillShapeField.label'];
	const {
		control,
		setScrollRef,
	} =	useFormContext();
	const scrollRef = useRef();
	const substanceForm: SubstanceForm = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE_FORM }) as SubstanceForm;
	const isPill = substanceForm === SUBSTANCE_FORM.PILL;

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: COMMON_FIELD_NAME.PILL_SHAPE_OTHER, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			className={isPill ? undefined : 'hidden'}
			elementRef={scrollRef}
			legend={isPill ? legend : undefined}
			legendClassName='font-normal text-lg'
			legendId={PILL_SHAPE_LEGEND_ID}
		>
			<PillShapeButtonGroup
				aria-labelledby={PILL_SHAPE_LEGEND_ID}
				phrases={phrases}
			/>
			<PillShapeOtherTextField
				phrases={phrases}
			/>
		</Fieldset>
	);
};
